import { createLucideIcon } from 'lucide-react';
export const StoreInformation = createLucideIcon('store-information', [
  [
    'path',
    {
      d: 'M19.5 6.5V4H4.5V6.5',
      key: '1e4x6u',
    },
  ],
  [
    'path',
    {
      d: 'M2 9.33333V9.10416L3 8L4.5 6.5H19.5L21 8L22 9.10416V9.33333C22 10.4297 21.1022 11.5726 20 11.5C19.4154 11.4615 18.6667 10.8125 18.6667 10.8125C18.6667 10.8125 17.8438 11.3333 17.3333 11.3333C16.8229 11.3333 16 10.8125 16 10.8125C16 10.8125 15.1771 11.3333 14.6667 11.3333C14.1562 11.3333 13.3333 10.8125 13.3333 10.8125C13.3333 10.8125 12.5104 11.3333 12 11.3333C11.4896 11.3333 10.6667 10.8125 10.6667 10.8125C10.6667 10.8125 9.84375 11.3333 9.33333 11.3333C8.82292 11.3333 8 10.8125 8 10.8125C8 10.8125 7.17708 11.3333 6.66667 11.3333C6.15625 11.3333 5.33333 10.8125 5.33333 10.8125C5.33333 10.8125 4.33011 11.3318 4 11.3333C2.89544 11.3385 2 10.4297 2 9.33333Z',
      key: 'kbemi2',
    },
  ],
  [
    'path',
    {
      d: 'M4 11V20H12.5V15H14.5H16.5V20H20V11',
      key: '12ybzi',
    },
  ],
]);
